import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {Link as RouterLink} from "react-router-dom";
import {useContext} from "react";
import {AuthenticationContext} from "@lectra/react-authentication";
import Box from "@mui/material/Box";

interface HomeProps {
  step: string;
}

export function Home({step}: HomeProps) {
    const authenticationContext = useContext(AuthenticationContext)

    console.log("Home step:", step);
    return (
        <>
            <Box display="flex" flexDirection="row" gap={2} justifyContent="center" >
                {authenticationContext.user && (
                    <Button component={RouterLink} to="/profileAuth0" variant="contained" color="primary"
                            sx={{minWidth: 180, maxWidth: 250}}>
                        Show user Auth0 info
                    </Button>
                )}
                <AuthenticatedTemplate>
                    <Button component={RouterLink} to="/profile" variant="contained" color="primary"
                            sx={{minWidth: 180, maxWidth: 250}}>
                        Request Profile Information
                    </Button>
                    <Button component={RouterLink} to="/channels" variant="contained" color="secondary"
                            sx={{minWidth: 180, maxWidth: 250}}>
                        Show user Teams channels
                    </Button>
                    <Button component={RouterLink} to="/messages" variant="contained" color="secondary"
                            sx={{minWidth: 180, maxWidth: 250}}>
                        Send messages
                    </Button>
                </AuthenticatedTemplate>
            </Box>

            <UnauthenticatedTemplate>
                <br/>
                <Typography variant="h6" align="center">Please sign-in to see your profile information.</Typography>
            </UnauthenticatedTemplate>
        </>
    );
}
